import { BigCheckbox, BigTextArea, FieldShell } from './FieldPrimitives';
import { MEDICAL_CONDITIONS } from '@/constants/intakeForm';

const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

const MedicalHistorySection = ({ responses, setField }) => {
  const conditions = responses.conditions || [];
  return (
    <div className="space-y-6">
      <p className="text-base md:text-lg text-gray-700">
        Check any condition you currently have or have had in the past. Skip any
        you do not know.
      </p>

      <FieldShell label="What conditions apply to you?">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {MEDICAL_CONDITIONS.map((cond) => (
            <BigCheckbox
              key={cond}
              id={`cond_${cond.replace(/\W+/g, '_')}`}
              checked={conditions.includes(cond)}
              onChange={() =>
                setField('conditions', toggleInList(conditions, cond))
              }
            >
              {cond}
            </BigCheckbox>
          ))}
        </div>
      </FieldShell>

      <FieldShell
        label="Other conditions or details"
        htmlFor="conditions_other"
        help="If you have a condition not listed above, describe it here."
      >
        <BigTextArea
          id="conditions_other"
          value={responses.conditions_other}
          onChange={(v) => setField('conditions_other', v)}
        />
      </FieldShell>

      <FieldShell
        label="Current medications"
        htmlFor="current_medications"
        help="Include any prescription medications, supplements, or herbs you are taking. Write 'None' if you take none."
      >
        <BigTextArea
          id="current_medications"
          value={responses.current_medications}
          onChange={(v) => setField('current_medications', v)}
        />
      </FieldShell>

      <FieldShell
        label="Allergies to medications"
        htmlFor="allergies"
        help="List anything you are allergic to. Write 'None' if you have none."
      >
        <BigTextArea
          id="allergies"
          value={responses.allergies}
          onChange={(v) => setField('allergies', v)}
        />
      </FieldShell>

      <FieldShell
        label="Past surgeries or hospitalizations"
        htmlFor="surgeries"
        help="List any past surgeries or hospital stays. Write 'None' if you have none."
      >
        <BigTextArea
          id="surgeries"
          value={responses.surgeries}
          onChange={(v) => setField('surgeries', v)}
        />
      </FieldShell>
    </div>
  );
};

export default MedicalHistorySection;
